import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from '../../../util/reactIntl';
import { Modal, PrimaryButton, SecondaryButton } from '../../../components';

import css from './SwapPieceModal.css';

const SwapPieceModalComponent = ({
  id,
  isOpen,
  onCloseModal,
  onManageDisableScrolling,
  currentPiece,
  listingTitle,
  onSubmitSwap,
  inProgress = false,
  error = null,
  intl
}) => {
  const [newPieceCode, setNewPieceCode] = useState('');
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) {
      setNewPieceCode('');
      setReason('');
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newPieceCode.trim() || !reason.trim() || inProgress) return;

    onSubmitSwap({
      oldPiece: currentPiece,
      newPiece: newPieceCode.trim(),
      reason: reason.trim()
    });
  };

  const isSubmitDisabled = !newPieceCode.trim() || !reason.trim() || inProgress;

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <form onSubmit={handleSubmit} className={css.modalContainer}>
        <h2 className={css.modalTitle}>
          <FormattedMessage id="SwapPieceModal.title" defaultMessage="Podmiana sztuki" />
        </h2>

        {listingTitle && <p className={css.listingTitle}>{listingTitle}</p>}

        <div className={css.currentPieceSection}>
          <span className={css.label}>
            <FormattedMessage id="SwapPieceModal.currentPiece" defaultMessage="Aktualna sztuka:" />
          </span>
          <div className={css.currentPieceBadge}>
            {typeof currentPiece === 'string' ? currentPiece : currentPiece?.code || currentPiece?.id}
          </div>
        </div>

        <div className={css.formGroup}>
          <label htmlFor="newPieceCode" className={css.label}>
            <FormattedMessage id="SwapPieceModal.newPieceLabel" defaultMessage="Nowy numer sztuki / kod:" />
          </label>
          <input
            id="newPieceCode"
            type="text"
            className={css.input}
            placeholder={intl.formatMessage({
              id: 'SwapPieceModal.newPiecePlaceholder',
              defaultMessage: 'Wpisz lub zeskanuj nowy numer...'
            })}
            value={newPieceCode}
            onChange={(e) => setNewPieceCode(e.target.value)}
            disabled={inProgress}
            autoFocus
          />
        </div>

        <div className={css.formGroup}>
          <label htmlFor="swapReason" className={css.label}>
            <FormattedMessage id="SwapPieceModal.reasonLabel" defaultMessage="Powód podmiany:" />
          </label>
          <textarea
            id="swapReason"
            rows="3"
            className={css.textarea}
            placeholder={intl.formatMessage({
              id: 'SwapPieceModal.reasonPlaceholder',
              defaultMessage: 'np. Uszkodzenie sprzętu, błędnie zeskanowany kod...'
            })}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            disabled={inProgress}
          />
        </div>

        {error && (
          <div className={css.error}>
            <FormattedMessage id="SwapPieceModal.errorMessage" defaultMessage="Wystąpił błąd podczas podmiany sztuki." />
          </div>
        )}

        <div className={css.buttonGroup}>
          <SecondaryButton type="button" onClick={onCloseModal} disabled={inProgress}>
            <FormattedMessage id="SwapPieceModal.cancel" defaultMessage="Anuluj" />
          </SecondaryButton>
          <PrimaryButton type="submit" inProgress={inProgress} disabled={isSubmitDisabled}>
            <FormattedMessage id="SwapPieceModal.confirm" defaultMessage="Zatwierdź podmianę" />
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  );
};

export default injectIntl(SwapPieceModalComponent);